import * as yup from 'yup'
import moment from 'moment'

export const validationSchema = yup.object().shape({
  healthInsurance: yup.object().shape({
    health_insurance_code: yup.string().required(),
    health_card: yup
      .string()
      .max(25, 'Máximo de 25 caracteres')
      .when('health_insurance_code', {
        is: '304',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.required('Número da carteira é obrigatório')
      }),
    // company_name: yup.string(),
    valid_thru: yup
      .date()
      .typeError('Data Inválida')
      .min(moment().utc(), 'A data precisa ser maior que a data atual')
      .format('DD/MM/YYYY', true)
    // .required()
  })
})
